$(document).ready(function(){
 
  $body = $("body");
  
  	$(".img-upload").change(function(){

		$body.addClass("loading");
      	//$body.addClass("waiting-text");
        var timestamp = Math.round((new Date).getTime()/1000);
        var fd = new FormData();

  		var params = new URLSearchParams();       
		// append parameters
		params.append('timestamp', timestamp + 'UNxLsVtXtD-gORPJQfgxti5mIJM');
      	params.append('public_id', timestamp);
 
      	var attr;
      	var rmv_bkg;
      
      	var item_name =  this.id;
      	var preview_div = document.getElementById('img-preview');
      
		if(document.getElementById('_Attr')){      
 
          	attr = document.getElementById('_Attr').value;
        	eager = document.getElementById('_cld_eager').value;

            bgcolor = getBGColor();
            if(bgcolor !== false && eager.includes('[COLOR]')){
              var eager = eager.replace("[COLOR]", bgcolor);
            }

            bgcolor = getSecondaryColor();
            if(bgcolor !== false && eager.includes('[COLOR2]')){
              var eager = eager.replace("[COLOR2]", bgcolor);
            }
            
          
            font = getFont();
            if(font !== false && eager.includes('[FONT]')){
              var font = font.replace(' ', '+');
              var eager = eager.replace("[FONT]", font);
            }   

          
          	var text1 = document.getElementById("Text_1");
	        if(text1 && eager.includes('[TEXT]')){
    	    	var eager = eager.replace("[TEXT]", text1.value);
        	}
       

	        if(eager.includes('[RMV_BKG]')){
              	var rmv_bkg = 1;
              	params.append('background_removal', 'cloudinary_ai');
              	
        	}          
          
       		attr_array = attr.split('|');
        	eager_flg = attr_array[0];

     		if(eager_flg == 1){
          	/*var matches = eager.match(/{(.*?)}/g);
          	if (matches) {
              	console.log(matches);
              	for each(matches as match){
              		e = match.replace("[PRD:", "");
                  	e = e.substring(0, match.length - 1);
                  	console.log(e + ' is ' + e);
	              	var eager = eager.replace("[PRD:", "");
                }

			}*/
            
          	//params.append('eager', eager);
      		//params.append('eager_async','true');
          
          	if(eager.includes('[FILE]')){
				var eager = eager.replace("[FILE]", timestamp);
                //params.append('eager', eager);
        	}
         
          

        }
      	console.log(eager);
       }
     
  		params.sort();

      	// query string
      	var q = params.toString();
      	q = q.replace(/%2C/g, ',');
      	q = q.replace(/%3A/g, ':');
      	q = q.replace(/%7C/g, '|');
      	q = q.replace(/%20/g, '+');
      	//console.log(q);
      	s = sha1(q);
      
        var fd = new FormData();
  		fd.append ('public_id', timestamp);
        //fd.append ('upload_preset', 'ujqlipbt');
        //fd.append ('tags', 'map');
        //fd.append ('context', 'photo=phototitle');  
        fd.append ('api_key', '333585186628581');
        fd.append ('timestamp', timestamp);
     	/*if(eager_flg == 1){
	      	fd.append ('eager', eager); 
            fd.append ('eager_async','true');
        }*/
      	if(rmv_bkg == 1){
      	  	fd.append ('background_removal', 'cloudinary_ai'); 
        }
        fd.append ('signature', s);

		var files = this.files[0];
      	fd.append('file',files);

      	if(files == 'undefined'){
          	alert("Please choose an Image to Upload");
          	$body.removeClass("loading");
        }
          else{
            /*if(rmv_bkg == 1){
               return new Promise(function (resolve, reject) { 
            }*/
            
            $.ajax({
              url: 'https://api.cloudinary.com/v1_1/dtdlwv90j/image/upload',
              type: 'post',
              data: fd,
              contentType: false,
              processData: false,
              success: function(response){
                if(response != 0){
                  //console.log(response);
                  if(attr){
                    var img = new Image();
                    img.onload = function() {
                      imgwidth = this.width;
                      imgheight = this.height;
                      fill_canvas(img);
                      //setTimeout(function() { 
                      $body.removeClass("loading");
                      //alert('Image Uploaded'); 
                      //}, 300);

                    }
                    urlparts = response.secure_url.split("/");
                    if(rmv_bkg == 1){
                      //eager = eager.replace("[RMV_BKG]", 'v' + response.version + '/' + response.public_id); 
                      eager = eager.replace("[RMV_BKG]", response.public_id); 
                    }
                    console.log('https://res.cloudinary.com/dtdlwv90j/image/upload/' + eager);
                    img.src = 'https://res.cloudinary.com/dtdlwv90j/image/upload/' + eager;
                    //console.log(response);
                    //document.getElementsByClassName("product-single__media__image")[0].style.visibility = 'hidden';

                  }

                  // SGC 30 June 2022 remove customization if already exists fix
                  //if (document.contains(document.getElementById('customization'))) {
                    //document.getElementById('customization').remove();
                    //document.getElementById('Custom '+ item_name).remove();
                  //}
                  if (document.contains(document.getElementById('d-'+item_name))) {
                    document.getElementById('d-'+item_name).remove();
                    //document.getElementById('Custom '+ item_name).remove();
                    //document.getElementById('img-preview-img' + item_name).remove();
                  }
                  
                  // create new
                  var newdiv = document.createElement('div');
                  if(attr){ // dont show preview if eager
                    //newdiv.classList.add('d-'+item_name);
                    newdiv.setAttribute("id", 'd-'+item_name);
                    newdiv.innerHTML = item_name + "<br><input id='Custom "+ item_name +"' type='hidden' name='properties[Custom "+ item_name + "]' value='"+response.secure_url+"'>";
                  }
                  else{
                    //newdiv.classList.add('d-'+item_name);
                    newdiv.setAttribute("id", 'd-'+item_name);
                    newdiv.innerHTML = item_name + "<br><input id='Custom "+ item_name +"' type='hidden' name='properties[Custom "+ item_name + "]' value='"+response.secure_url+"'><img src='"+response.secure_url+"' id='img-preview-img"+item_name+"' width='150' height='150'>";
                  }
                  // then append

                  if (document.contains(document.getElementById('Custom '+ item_name))) {
                    document.getElementById('img-preview-img' + item_name).remove();
                    document.getElementById('Custom '+ item_name).remove();
                    preview_div.appendChild(newdiv);
                  }   else {
                    preview_div.appendChild(newdiv);
                  } 

                  if(!attr){
                    $body.removeClass("loading");
                  }
                  document.getElementById('img-preview').setAttribute("style","visibility:visible; display:'';");
                  
                  if(attr == 1){
                  	document.getElementById('canvasPreviewWrapper').setAttribute("style","visibility:visible; display:'';");
                  }
                  //document.getElementById("_custom_details").value = response.secure_url;


                  var items = document.getElementsByClassName('img-upload');
                  for (var i=0; i < items.length; i++) {
                    items[i].name = '';
                  }

                }else{
                  $body.removeClass("loading");
                  alert('file not uploaded');
                }
              },
              error: function (response) {
                $body.removeClass("loading");
                alert(response.responseText);
              }
            });

            
          /*if(rmv_bkg == 1){
         	 }); // end of rmv bg promise 
          }*/
            

         } // check if file exists
      
      
    }); /// end of upload
  

  
    function fill_canvas(img) {

        var canvas = document.getElementById('canvasPreview');
        var context = canvas.getContext('2d');

        //console.log(img.src);
        canvas.width = img.width;
        canvas.height = img.height;
        //canvas.setAttribute("style","border-width: 10px; border-style: solid;");
        context.drawImage(img,0,0);   


    }  

function getFont(){
  var zele = document.getElementsByName('properties[Font]'); 

  if(document.getElementsByName('properties[Font]').length > 0){
  
    for(i = 0; i < zele.length; i++) { 
      if(zele[i].checked) 
        font = zele[i].value; 
    } 
	return font;
   
  }
  else{
	return false;
  }
}
  
function getBGColor(){
  if(document.getElementsByName('properties[primarycolor]').length > 0){
  var bgcolor = null;
  //var zele = document.getElementsByName('properties[primarycolor]'); 

  //  for(i = 0; i < zele.length; i++) { 
  //    if(zele[i].checked) 
  //      bgcolor = zele[i].value; 
  //  }
  
  /*bgcolor = document.getElementById("Colour / Color").value;*/
  bgcolor = document.getElementById("primarycolor").value;
  var bgcolor_nohex = bgcolor.replace("#", "");
  //console.log(bgcolor);
  	return bgcolor_nohex;
  }
  else{
	return false;
  }
  
}


function getSecondaryColor(){
  if(document.getElementsByName('properties[secondarycolor]').length > 0){
  var bgcolor = null;
  //var zele = document.getElementsByName('properties[primarycolor]'); 

  //  for(i = 0; i < zele.length; i++) { 
  //    if(zele[i].checked) 
  //      bgcolor = zele[i].value; 
  //  }
  
  /*bgcolor = document.getElementById("Colour / Color").value;*/
  bgcolor = document.getElementById("secondarycolor").value;
  var bgcolor_nohex = bgcolor.replace("#", "");
  //console.log(bgcolor);
  	return bgcolor_nohex;
  }
  else{
	return false;
  }
  
}

$('#canvasPreview').bind("contextmenu",function(e){
        return false;
    });
  
});
